import * as React from 'react';
import './TabsV.scss';

interface ITabTitleData {
  id: number;
  name: string;
}

interface ITabsVProps {
  title?: string;
  tabTitles: ITabTitleData[];
  tabContents: React.ReactNode[];
  currentTab: number;
  selectTab: (index: number) => void;
}

const TabsV: React.FC<ITabsVProps> = props => {
  const { title, tabTitles, tabContents, currentTab, selectTab } = props;

  const renderContent = () => {
    return tabContents[currentTab];
  };

  return (
    <div className="rp-tabs-v">
      <div className="rp-tabs-v-options-container">
        <h1 className="rp-tabs-v-title">{title}</h1>
        {tabTitles.map((tabs, index) => (
          <a
            key={tabs.id}
            onClick={() => selectTab(index)}
            className={`rp-tabs-v-option ${index === currentTab && 'active'}`}
          >
            {tabs.name}
          </a>
        ))}
      </div>

      <div className="rp-tabs-v-content">{renderContent()}</div>
    </div>
  );
};

export default TabsV;
